<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>垫付报销单列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.woid"
                    style="width: 150px"
                    placeholder="代采单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    style="width: 150px"
                    placeholder="货号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    style="width: 200px"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    style="width: 200px"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="selectPgid">
                  <el-select
                    v-model="form.pgid"
                    style="width: 200px"
                    placeholder="选择代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectPgid"
                      :key="item.key"
                      :label="item.pgname"
                      :value="item.pgid"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="提交时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="支付时间：">
                  <el-date-picker
                    v-model="form.pay_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 40px;
            line-height: 45px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-tabs
            v-model="reim_status"
            style="margin-left: -25px; height: 45px; background: blanchedalmond"
            value="wait"
            type="border-card"
            @tab-click="clikTab"
          >
            <el-tab-pane label="全部" style="width: 70%" name="all">
            </el-tab-pane>
            <el-tab-pane label="所有待报销" name="wait"> </el-tab-pane>
          </el-tabs>
          <el-button
            v-if="reim_status == 'wait'"
            style="
              position: absolute;
              margin-left: 1100px;
              width: 100px;
              background-color: #fd8b3b;
            "
            type="success"
            size="mini"
            @click="reimAllClick"
            >一键报销</el-button
          >
          <el-button
            style="position: absolute; margin-left: 1220px; width: 70px"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="allData"
            ref="multipleTable"
            v-loading="tableLoading"
            type="expand"
            height="500"
            :data="allData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-form
                  label-position="left"
                  inline
                  class="demo-table-expand"
                  style="height: 80px; background-color: rgb(232, 232, 232)"
                >
                  <el-form-item
                    style="width: 100px; margin-left: 100px; margin-top: 10px"
                  >
                    <div>
                      <img
                        style="width: 50px; height: 50px"
                        :src="origin + '/' + scope.row.goods_img"
                        @click="
                          previewImage(origin + '/' + scope.row.goods_img)
                        "
                      />
                    </div>
                  </el-form-item>
                  <el-form-item style="width: 250px; margin-top: 10px">
                    <span style="font-size: 15px">{{
                      scope.row.goods_name
                    }}</span>
                  </el-form-item>
                  <el-form-item style="width: 150px; margin-top: 10px">
                    <span style="font-size: 15px">{{
                      "款号:" + scope.row.goods_kh
                    }}</span>
                  </el-form-item>
                  <el-form-item style="width: 150px; margin-top: 10px">
                    <span style="font-size: 15px">{{
                      "商家:" + scope.row.supply_name
                    }}</span>
                  </el-form-item>
                  <el-form-item style="width: 200px; margin-top: 10px">
                    <span style="font-size: 15px">{{
                      "订单商品编号:" + scope.row.woiid
                    }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="woid"
              label="代采单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="货号"
              width="120px"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wo_num"
              label="数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="price"
              label="单价"
            ></el-table-column>
            <el-table-column align="center" prop="total_price" label="金额">
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.wo_num * scope.row.price).toFixed(2) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="in_num"
              label="已回货"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="reimed_num"
              label="已报销"
            ></el-table-column>
            <el-table-column align="center" label="报销总额" width="120">
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.reimed_num * scope.row.price).toFixed(2) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="wait_reim_num"
              label="待报销"
            ></el-table-column>
            <el-table-column align="center" label="待报销金额">
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.wait_reim_num * scope.row.price).toFixed(2) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="status_label"
              label="代采单状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="prepay_people"
              label="垫付人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="提交时间"
              width="100px"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_time"
              label="支付时间"
              width="100px"
            ></el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看详情</el-button
                >
                <el-button
                  v-if="scope.row.wait_reim_num > 0"
                  type="text"
                  size="small"
                  @click="reimOneClick(scope.row)"
                  >报销</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.total_num"
            :page-size="20"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <el-dialog
          :visible.sync="dialogVisible"
          style="width: 80%; height: auto"
        >
          <img width="auto" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Global_ from "../components/Global";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      origin: Global_.origin,
      resData: null,
      allData: 0,
      form: {},
      loading: false,
      tableLoading: false,
      url: "/erp/Reimbursement/ReimList",
      reimUrl: "/erp/Reimbursement/operReim",
      status: -1,
      curPage: 1,
      filterFold: false,
      selectPgid: [],
      planStatus: [],
      multipleSelection: [],
      reim_status: "all",
      dialogImageUrl: "",
      dialogVisible: false,
      total_wait_num: 0,
      total_reim_price: 0,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.allData = res.data.data.allData;
        }
      });
      this.$http.post("/erp/Common/selectPgid", {}).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.selectPgid = res.data.data;
        }
      });
    }, // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.allData = res.data.data.allData;
        }
      });
    },
    handleDetail(row) {
      this.$router.push(`/home/purchaseplandetail/${row.planid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.allData = res.data.data.allData;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    reimOneClick(row) {
      this.$confirm(
        `报销:${row.wait_reim_num}件,计¥${row.wait_reim_num * row.price}元`,
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const params = { reim_id: row.reim_id };
        this.$http.post(this.reimUrl, params).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.fetchData();
            this.$message({
              type: "success",
              message: "单行报销操作成功!",
            });
          }
        });
      });
    },
    reimAllClick() {
      // 统计总件数和总金额
      this.loading = true;
      const params = this.filteredForm;
      params.is_sum = 1;
      const getData = new Promise((resolve, reject) => {
        this.$http.post(this.url, params).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.total_wait_num == 0) {
              this.$message.error(
                "未获取到需要报销的单据,请检查页面查询条件是否有误"
              );
              this.loading = false;
              return;
            }
            resolve(res.data.data);
          } else {
            this.loading = false;
            reject("未获取到需要报销的单据,请检查页面查询条件是否有误!");
          }
        });
      });

      // 这里不设置的话,filteredFrom会更改了is_sum=1
      params.is_sum = 0;
      getData
        .then((response) => {
          this.loading = false;
          this.verifyDialog(response);
        })
        .catch(function (error_msg) {
          this.$message.error(error_msg);
        });
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    verifyDialog(response) {
      this.$confirm(
        `报销:${response.total_wait_num}件,计¥${response.total_reim_price}元`,
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$http.post(this.reimUrl, this.filteredForm).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.fetchData();
              this.$message({
                type: "success",
                message: "一键报销操作成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    clikTab(tab) {
      if (tab.name == "wait") {
        // 查询所有待报销
        this.form.reim_status = 1;
      } else {
        this.form.reim_status = 0;
      }
      this.fetchData();
    },
    previewImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReimbursementList.vue